import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import BaseModal from "../shared/BaseModal";
import { Button } from 'reactstrap';
import { requestBinary } from '../../helpers/requests';
import { API, BASE_URL } from '../../CONST';
import { useSelector } from 'react-redux';

const LibroVentasCierreConfirmacionModal = ({ isOpen, onConfirm, onCancel, message }) => {
  const [firstPart, secondPart] = message.split('?');
  //const filteredData = Array.isArray(data.data) ? data.data.filter(item => item.libro_venta_id !== null) : [];
  const [solicitandoArchivos, setSolicitandoArchivos] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const loginIdToken = useSelector((state) => state.login.id_token);

  useEffect(() => {
    if (isOpen) {
      setErrorMessage('');
    }
  }, [isOpen]);

  const downloadFile = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const handleDownload = async () => {
    setSolicitandoArchivos(true);
  
    try {
      const blob = await requestBinary(
        'POST',
        `${BASE_URL}${API.createResumenLibroVentas}/`,
        {},
        true,
        loginIdToken
      );
      downloadFile(blob, 'resumen_libro_ventas_cierre.xlsx');
      onConfirm();
    } catch (error) {
      if (error.message && error.message.includes("status: 400")) {
        setErrorMessage("No hay libros para generar el resumen");
      }
      else {
        setErrorMessage("Ocurrió un error al generar el resumen");
      }
    } finally {
      setSolicitandoArchivos(false);
    }
  };

  return (
    <BaseModal
      modalOpen={isOpen}
      handleModal={onCancel}
      type="confirmation-modal"
    >
      <div style={{ textAlign: "center", padding: "20px", color: "var(--orsan-dark-grey)" }}>
        {errorMessage ? (
          <>
            <p style={{ fontWeight: "bold" }}>{errorMessage}</p>
            <Button onClick={onCancel} className="btn btn-secondary">
              Cerrar
            </Button>
          </>
        ) : (
          <>
            <p style={{ fontWeight: "bold" }}>
              {firstPart}?
            </p>
            <p style={{ fontWeight: "bold" }}>
              {secondPart}
            </p>
            <div style={{ marginTop: "20px" }}>
              <Button
                onClick={handleDownload}
                disabled={solicitandoArchivos}
                style={{ marginRight: "10px", backgroundColor: "var(--orsan-blue-s1)", borderColor: "var(--orsan-blue-s1)" }}
                className="btn btn-primary"
              >
                {solicitandoArchivos ? 'Procesando...' : 'Descargar Resumen'}
              </Button>
              <Button onClick={onCancel} className="btn btn-secondary">
                Cancelar
              </Button>
            </div>
          </>
        )}
      </div>
    </BaseModal>
  );
};

LibroVentasCierreConfirmacionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};

export default LibroVentasCierreConfirmacionModal;
